import { useEffect } from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import i18n from 'i18n-calypso';

export default function I18NController() {
	useEffect(
		() => {
			// @todo once we have translations and a way to determine which locale to use:
			// i18n.setLocale( LOCALE_DATA_JED_JSON );
		},
		[]
	);

	return null;
};
